import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit, OnDestroy {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  
  constructor(
    private store: Store,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);
  }
}
